import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { RootState } from "../../redux/store";

type Props = {
  role: number | string;
};

export default function AllowRole({ role }: Props) {
  const { user } = useSelector((store: RootState) => store.user);

  return user.TIPO == role ? <Outlet /> : <Navigate to={"/login"} replace />;
}
